import { createSelector } from 'reselect';

import {
  BADGE_USER_DETAILS,
  SET_BADGE_USER_DETAILS_STATUS,
} from 'actions/badge.actions';
import { ErrorTypes } from 'interfaces/auth.types';
import { ActionType } from 'interfaces/actions.types';
import { BadgeType } from 'interfaces/badge.types';
import { FAILURE, SUCCESS } from 'services/api';
import { LoadingStatusType } from 'interfaces';

export interface BadgeState {
  byId: {
    [id: string]: {
      data: BadgeType;
      error: ErrorTypes | null;
      status: LoadingStatusType;
    };
  };
}

export const initialState: BadgeState = {
  byId: {},
};

export const badgeReducerSelector = (state: {
  badge: BadgeState;
}): BadgeState => state.badge;

export const badgesSelector = (id: string | number) =>
  createSelector(badgeReducerSelector, (badge) => badge.byId[id]);

export const badgeReducer = (
  state: BadgeState = initialState,
  action: ActionType,
): BadgeState => {
  const { payload } = action;

  switch (action.type) {
    case SET_BADGE_USER_DETAILS_STATUS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            status: payload.status,
          },
        },
      };
    case BADGE_USER_DETAILS[SUCCESS]:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            data: payload.badge,
            error: null,
          },
        },
      };
    case BADGE_USER_DETAILS[FAILURE]:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            data: null,
            error: payload.error,
          },
        },
      };
    default:
      return state;
  }
};

export default badgeReducer;
